var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showModal)?_c('div',{staticClass:"modal-overlay",on:{"click":function($event){!_vm.backdrop && _vm.overlayCloses && _vm.onCloseModal()}}}):_vm._e(),_vm._v(" "),_c('div',{class:{
      'sida-modal': true,
      'download-progress-modal': true,
      show: _vm.showModal,
      error: _vm.error
    },style:(_vm.styles),attrs:{"data-close":"disabled"}},[_c('h2',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(!_vm.preventClose)?_c('div',{staticClass:"modal-btn-close",on:{"click":function($event){return _vm.onCloseModal()}}},[_vm._v("\n      ×\n    ")]):_vm._e(),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }